import React from 'react';
import { Result, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { isSessionValid } from '../../Utils/session';

/**
 * Public Stripe success redirect. Handoff Flow E: no invoice id / session id is
 * in the URL, so the page must work without query params. It does NOT change
 * payment state - the signed Stripe webhook is authoritative. It only tells the
 * user the payment was submitted and (if signed in) offers a return to invoices.
 */
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const authed = isSessionValid();
  return (
    <div className="auth-viewport">
      <div className="auth-card" style={{ maxWidth: 520 }}>
        <Result
          status="success"
          title="Payment submitted"
          subTitle="Thank you. Your payment was submitted and confirmation can take a few seconds. The invoice will update automatically once the payment is confirmed."
          extra={
            <Space>
              {authed && (
                <Button type="primary" onClick={() => navigate('/cfo/invoices')}>
                  Return to Invoices
                </Button>
              )}
            </Space>
          }
        />
      </div>
    </div>
  );
};

export default PaymentSuccess;
